"use client";

import { c as _c } from "react/compiler-runtime";
import { useRefinementList } from "react-instantsearch";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { PlpFilterValueConfig } from "@/lib/contentful/filterGroups";
import { cn } from "@/lib/utils";
import { PlpRefinementListDynamic } from "./PlpRefinementListDynamic";
interface Props {
  attribute: string;
  values: PlpFilterValueConfig[];
  // When true, ignore the canonical `values` list and render directly from
  // useRefinementList's items via PlpRefinementListDynamic. Used for groups
  // like Materials whose catalog churns too fast to keep in sync via Contentful.
  dynamic?: boolean;
}
export function PlpRefinementListFilter(t0) {
  const $ = _c(17);
  const {
    attribute,
    values,
    dynamic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["name:asc"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== attribute) {
    t2 = {
      attribute,
      operator: "or",
      limit: 50,
      sortBy: t1
    };
    $[1] = attribute;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    items,
    refine
  } = useRefinementList(t2);
  if (dynamic) {
    let t3;
    if ($[3] !== attribute || $[4] !== items || $[5] !== refine || $[6] !== values) {
      t3 = <PlpRefinementListDynamic attribute={attribute} items={items} values={values} refine={refine} />;
      $[3] = attribute;
      $[4] = items;
      $[5] = refine;
      $[6] = values;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  let t4;
  if ($[8] !== attribute || $[9] !== items || $[10] !== refine || $[11] !== values) {
    const itemByKey = new Map(items.map(_temp));
    t3 = "flex flex-col gap-2";
    t4 = values.map(value => {
      const inputId = `plp-${attribute}-${value.slug}`;
      const item_0 = itemByKey.get(value.productAttributeKey);
      const count = item_0?.count ?? 0;
      const isRefined = item_0?.isRefined ?? false;
      const disabled = !isRefined && (item_0 === undefined || count === 0);
      const handleToggle = function handleToggle() {
        if (disabled) {
          return;
        }
        if (item_0) {
          refine(item_0.value);
        }
      };
      return <div key={value.slug} className="flex items-center gap-2"><Checkbox id={inputId} aria-label={value.label} checked={isRefined} disabled={disabled} aria-disabled={disabled ? "true" : undefined} onCheckedChange={disabled ? undefined : handleToggle} /><Label htmlFor={inputId} className={cn("flex-1 cursor-pointer text-sm font-medium", disabled && "text-muted-foreground opacity-50 cursor-not-allowed")}>{value.label}</Label><span className={cn("text-sm text-muted-foreground", disabled && "opacity-50")}>({count})</span></div>;
    });
    $[8] = attribute;
    $[9] = items;
    $[10] = refine;
    $[11] = values;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp(item) {
  return [item.value, item];
}